<script setup lang="ts">
type HeroPanelSwitcherProps = {
  variant: string
}

const props = defineProps<HeroPanelSwitcherProps>()

const currentComponent = computed(() => {
  switch (props.variant) {
    case 'standard':
      return resolveComponent('HeroPanelStandardSwitcher')
    case 'fullWidthHero':
    case 'fullWidthImage':
    default:
      return resolveComponent('HeroPanel')
  }
})
</script>

<template>
  <component :is="currentComponent" v-bind="{ ...$props, ...$attrs, variant }" />
</template>
